import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  public employeeDetails = new BehaviorSubject<any>(null);
  public teams = new BehaviorSubject<any>(null);
  public memberships = new BehaviorSubject<any>(null);
  excelContent: any;
  constructor() { }

  setExcelData(data) {
    this.excelContent = data;
  }

  getExcelData() {
    return this.excelContent
  }
}
